export default "__VITE_ASSET__xKAve6kA__"